<template>
    <div class="card" :class="{'noheader': !headerText}">
        <div class="card-header">
            <slot name="card-pre-header"></slot>
            <div class="card-header__side-l">
                <i :class="headerIcon" v-if="headerIcon" class="mr-2"></i>
                <strong class="card-title" v-if="headerText">{{headerText}}</strong>
                <small v-if="smallText">{{smallText}}</small>
            </div>
            <div class="card-header__side-r">
                <slot name="card-header"></slot>
            </div>
      </div>
        <div class="card-body">
            <slot></slot>
        </div>
        <div class="card-footer" v-if="footerText">
            {{ footerText }}
            <slot name="card-footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'card-template',

  props: [
    'headerIcon',
    'headerText',
    'footerText',
    'smallText'
  ]
}
</script>

<style lang="scss">
    .noheader .card-header{
        display: none;
    }
    .card {
        &-header {
            display: flex;
            flex-wrap: wrap;
            &__side-l {
                flex-shrink: 0;
            }
            &__side-r {
                flex-grow: 1;
                // flex-shrink: 0;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-end;

                select,
                input {
                    width: auto;
                    max-width: 160px;
                }
                > * {
                    margin-left: 10px;
                }
            }
        }
        &-body {
            iframe {
                width: 100% !important;
            }
        }
    }
</style>
